import styled from 'styled-components';

export const SummaryValueSpan = styled.span`
  text-align: right;
`;

export const SummaryRow = styled.span`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
`;
